import { SharedState } from '@trello/shared-state';

export const featureFlagUserDataRefinedState = new SharedState(false);
